import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { SettingsService } from '../../services/settings.service';
import { StateService } from '../../services/state.service';
import { StateRxService } from '../../services/staterx.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'hcf-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '[class.home]': 'isHome',
    '[class.mobile]': 'isMobile', // Add a class when displaying a home page, homepage has different layout
  },
  standalone: false,
})
export class AppComponent implements OnInit {
  isHome: boolean = false;
  isLoading: boolean = false; // Don't show component loading progress bar by default
  isMobile: boolean = false;
  showMessage: boolean = false;
  messageText: string;
  messageBoxClass: string;

  constructor(
    private _router: Router,
    // private _location: Location,
    private _stateService: StateService,
    private _stateRxService: StateRxService,
    public _gaService: GoogleAnalyticsService,
    private _uiService: UiService,
  ) {}

  ngOnInit() {
    this.isMobile = this._uiService.isMobile();

    // Subscribe to router changes to add/remove the home css class.
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isHome = this._router.url === '/' || this._router.url.startsWith('/?');
      }
    });

    // Display a loader when changing routes. Subscribe to rxJs event triggered when routed components start and finish loading data.
    this._stateRxService.isLoading.rxSubscribe((isLoading) => {
      this.isLoading = isLoading;
    });

    // Some css styles a simple to set/unset if there is a parent class identifying if the layout is mobile
    this._stateRxService.mobileLayoutChanged.rxSubscribe((isMobile) => {
      this.isMobile = isMobile;
    });

    this._stateRxService.hasError.rxSubscribe((isError) => {
      // Stop loading animation in case if it was on.
      this.isLoading = false;

      this.showMessage = isError;
      const errorMessage = SettingsService.uiMessage.genericError;
      this.messageText = isError ? (this.messageText = errorMessage.text) : '';
      this.messageBoxClass = errorMessage.class;
    });

    // Check for GTM notification test
    const urlParams = new URLSearchParams(window.location.search);
    const testNotificiationParam = urlParams.get('testnotification');

    if (testNotificiationParam === '1') {
      (<any>window)._gtmNotification = {
        body:
          'I am a custom notification! I am a custom notification! I am a custom notification![!]' +
          'I am the body text!  I am the body text!  I am the body text!  I am the body text!I am the body text!  ' +
          'I am the body text!  I am the body text!  I am the body text!I am the body text!  I am the body text!  ' +
          'I am the body text!  I am the body text!I am the body text!  I am the body text!  I am the body text!',
      };
    } else if (testNotificiationParam === '2') {
      (<any>window)._gtmNotification = {
        body:
          'I am a survey banner! I am a survey banner! I am a survey banner![!]' +
          'I am the body text!  I am the body text!  I am the body text!  I am the body text!I am the body text!  ' +
          'I am the body text!  I am the body text!  I am the body text!I am the body text!  I am the body text!  ' +
          'I am the body text!  I am the body text!I am the body text!  I am the body text!  I am the body text!',
        location: 'results',
      };
    } else if (testNotificiationParam === '3') {
      (<any>window)._gtmNotification = {
        body:
          'I am a survey banner! I am a survey banner! I am a survey banner![!]' +
          'I am the body text!  I am the body text!  I am the body text!  I am the body text!I am the body text!  ' +
          'I am the body text!  I am the body text!  I am the body text!I am the body text!  I am the body text!  ' +
          'I am the body text!  I am the body text!I am the body text!  I am the body text!  I am the body text!',
        type: 'survey-banner',
      };
    } else if (testNotificiationParam === '4') {
      (<any>window)._gtmNotification = {
        body:
          'I am a custom notification! I am a custom notification! I am a custom notification! ' +
          'I am the body text!  I am the body text!  I am the body text!  I am the body text!I am the body text!  ' +
          'I am the body text!  I am the body text!  I am the body text!I am the body text!  I am the body text!  ' +
          'I am the body text!  I am the body text!I am the body text!  I am the body text!  I am the body text!',
      };
    }

    // Check for custom notifications via GTM
    window.setInterval(() => {
      const msg = (<any>window)._gtmNotification;
      if (msg && msg.body) {
        this._stateService.setCustomMessage(msg);
        (<any>window)._gtmNotification = null;
      }
    }, 1000);
  }

  onCloseClick() {
    this.showMessage = false;
  }
}
